module.exports = __webpack_public_path__ + "img/brouette-01_fond-transparent.b78fb69d.png";